import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import Button from 'src/ui/wards/common/button/Button';
import LinkButton from 'src/ui/wards/common/button/LinkButton';
import { wardsNavigate } from 'src/ui/wards/router/WardsScreenRegistration';
import { WaScreensMap } from 'src/ui/wards/router/WardsScreenMap';
import { WA_Screen } from 'src/ui/wards/router/WardsScreens';
import { useWaDisasterStore } from 'src/api/wa/store/WaRegionAndDisasterStore';
import { useWaProductStore } from 'src/api/wa/store/WaProductStore';
import { getDetailStatusTranslationKey } from 'src/api/wa/store/models/workplace/OperationStatus';
import { useEffect } from 'react';
import { useWaWorkplaceStore } from 'src/api/wa/store/WaWorkplaceStore';
import useWaProductService from 'src/api/wa/service/WaProductService';

function S_TargetProductList() {
  const { products, setSelectedProduct } = useWaProductStore();
  const { fetchProducts } = useWaProductService();
  const { selectedDisaster } = useWaDisasterStore();
  const { selectedWorkplace } = useWaWorkplaceStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedWorkplace) {
      fetchProducts(selectedWorkplace);
    }
  }, [fetchProducts, selectedWorkplace]);

  const backNavigation = () => {
    navigate(-1);
  };

  return (
    <div className="flex min-h-screen flex-col bg-gray-100 px-4 pt-8">
      <h2 className="mb-6 text-center text-2xl font-bold">{t('wards.targetProductList.title')}</h2>
      <div className="justify-center pb-4 text-center text-xl">{`${t('wards.targetProductList.subtitle')}${selectedDisaster?.id}`}</div>
      <div className="pb-8">
        <Button title={t('wards.common.back')} onClick={backNavigation} />
      </div>

      <div className="w-full overflow-x-auto text-lg">
        <div className="grid min-w-full" style={{ gridTemplateColumns: 'min-content 1fr 1fr' }}>
          <div className="contents">
            <div className="whitespace-nowrap pb-2 pr-2 text-xs font-bold text-gray-800">
              {t('wards.targetProductList.productNumber')}
            </div>
            <div className="whitespace-nowrap px-4 pb-2 text-xs font-bold text-gray-800">
              {t('wards.targetProductList.unit')}
            </div>
            <div className="whitespace-nowrap pb-2 pl-4 text-xs font-bold text-gray-800">
              {t('wards.targetProductList.latest')}
            </div>
          </div>

          {products.map((row) => (
            <div key={row.productNumber} className="contents">
              <div className="whitespace-nowrap border-t border-gray-300 py-6 pr-2 text-xs">
                <LinkButton
                  title={`${row.productNumber}`}
                  onClick={() => {
                    setSelectedProduct(row);
                    wardsNavigate(navigate, WaScreensMap[WA_Screen.ProductDetails].path);
                  }}
                />
              </div>
              <div className="overflow-hidden truncate whitespace-nowrap border-t border-gray-300 py-6 pr-2 text-xs">
                {row.unit}
              </div>
              <div className="overflow-hidden truncate whitespace-nowrap border-t border-gray-300 py-6 text-xs">
                {t(getDetailStatusTranslationKey(row.statusId))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="py-8">
        <Button title={t('wards.common.back')} onClick={backNavigation} />
      </div>
    </div>
  );
}

export default S_TargetProductList;
